<template>
  <div class="bs-wrapper questionnaire flex-col">
    <!-- <s-h-header :onClickLeft="() => $bsUtils.nativeApi.goBack()" /> -->
    <div class="content q-content" ref="content" v-if="!loading">
      <div
        class="img-box"
        :style="{
          background: `url(${info.headImg ||
            require('../../assets/img/questionnaire/bg_default.png')}) no-repeat`,
          backgroundSize: '100% 100%',
        }"
      >
        <div class="img-text">{{ info.title }}</div>
      </div>
      <div class="tip-box view-box">
        {{ info.desc }}
      </div>
      <div class="tip-box view-box plaza-box flex-col" v-if="isWx">
        <span style="margin-bottom: 6px;">广场名称：{{ info.plazaName }}</span>
        <span>店铺名称：{{ info.storeName }}</span>
      </div>
      <div class="view-box q-box" ref="qBox" v-if="questionsInfo.list.length">
        <div class="q-header flex-row">
          <div class="title">
            {{ questionsInfo.list[questionsInfo.step].name }}
          </div>
          <div class="step">
            答题进度 {{ questionsInfo.step + 1 }}/{{
              questionsInfo.list.length
            }}
          </div>
        </div>
        <question
          v-model="questionsInfo.list[questionsInfo.step].q"
          :canNotEdit="hasCommit"
          :isCollection="isCollection"
        />
      </div>
      <div class="btn-box flex-row">
        <s-h-button v-if="questionsInfo.step" @click="flipOverHandler('prev')"
          >上一页</s-h-button
        >
        <s-h-button
          type="primary"
          :style="{
            background:
              questionsInfo.list.length === questionsInfo.step + 1 && hasCommit
                ? '#ccc'
                : '',
          }"
          :disabled="hasCommit"
          :size="!questionsInfo.step ? 'large' : 'medium'"
          @click="flipOverHandler('next')"
          >{{
            questionsInfo.list.length === questionsInfo.step + 1
              ? hasCommit
                ? '已填写'
                : '提交'
              : '下一页'
          }}
        </s-h-button>
      </div>
    </div>
    <Loading v-else class="q-loading" />
    <Dialog
      v-model="showCAPTCHA"
      title="提示"
      className="collectionBox"
      :showConfirmButton="false"
    >
      <div class="collection" v-if="showCollection">
        <field
          v-model="collectionValue"
          autosize
          show-word-limit
          maxlength="200"
          type="textarea"
          placeholder="请填写满意原因"
        />
      </div>
      <div class="CAPTCHABox flex-row">
        <van-field
          v-model="identifyCodeValue"
          placeholder="请输入图片验证码"
          class="CAPTCHAInput"
          maxlength="4"
        />
        <CAPTCHA
          :identifyCode="identifyCode"
          :fontSizeMin="16"
          :fontSizeMax="18"
          :contentWidth="100"
        />
        <div class="nullBox" @click="refreshCode" />
        <van-icon @click="refreshCode" name="replay" />
      </div>
      <div class="btns">
        <div class="btn" @click="showCAPTCHA = false">取消</div>
        <div class="btn confirm"><span @click="confirmCAPTCHA">确定</span></div>
      </div>
    </Dialog>
  </div>
</template>

<script>
// import SHHeader from '@/components/ShHeader';
import Question from '@/views/Questionnaire/Question';
import SHButton from '@/components/ShButton';
import { questionnaireApi } from '@/api';
import { mapGetters } from 'vuex';
import 'vant/lib/loading/style';
import { isEmojiCharacter } from '@utils/flag';
import { Dialog, Field } from 'vant';
// import testData from './data';
import CAPTCHA from '@components/CAPTCHA';

export default {
  name: 'Questionnaire',

  mixins: [],

  components: {
    CAPTCHA,
    Question,
    SHButton,
    Loading: () => import('vant/lib/loading'),
    Dialog: Dialog.Component,
    Field,
  },

  props: {},

  data() {
    return {
      info: {
        headImg: '',
        title: '',
        desc: '',
      },
      questionsInfo: {
        step: 0,
        list: [],
      },
      queryParams: null,
      hasCommit: false,
      loading: true,
      isCollection: false, // 当前问卷是否为满意反馈收集
      showCAPTCHA: false,
      showCollection: false,
      collectionValue: '',
      identifyCode: '',
      identifyCodeValue: '',
      submitParams2: null,
      isWx: false,
    };
  },

  computed: {
    submitParams() {
      return this.questionsInfo.list
        .map(item => {
          return item.q.map(item => {
            return {
              response:
                item.value instanceof Array ? item.value.join('|') : item.value,
              topic: item.title,
              topicId: item.name,
            };
          });
        })
        .flat();
    },
    CAPTCHARight() {
      return this.identifyCode === this.identifyCodeValue;
    },
    ...mapGetters('account', {
      storeId: 'storeId',
    }),
    ...mapGetters('base', {
      resizeHeightScroll: 'resizeHeightScroll',
    }),
  },

  watch: {},

  created() {
    // let isEmptyQuery = JSON.stringify(this.$route.query) === '{}';
    // this.queryParams = isEmptyQuery ? {
    //   eventId: '435759240897794048',
    //   id: 'ubBz53sBbVrpOyyXKHxi',
    //   noticeType: 3,
    //   storeId: 3026594,
    //   type: 8
    // } : this.$route.query;

    let params = {
      eventId: this.$route.query.eventId,
      id: this.$route.query.id,
      type: this.$route.query.type,
      noticeType: this.$route.query.noticeType,
    };
    this.queryParams = Object.assign(params, { storeId: this.storeId });
    this.isWx = localStorage.getItem('wxAuth') === '1';
    this.initData();
  },

  mounted() {},

  destroyed() {},

  methods: {
    /**
     * 初始化数据并获取问卷信息
     * @returns {Promise<*|VanToast>}
     */
    async initData() {
      // this.info.id = this.$route.query.qId;
      const [err, res] = await this.$bsUtils.request(
        questionnaireApi.getSurvey(this.queryParams)
      );
      this.loading = false;
      if (err) {
        await this.$router.replace({
          name: 'questionFallback',
          params: { err },
        });
        // if (err.status && err.status === '5017') {
        //   this.$router.replace({ name: 'questionnaire-fallback', params: { status: err.status } });
        //   return
        // } else {
        //   return this.$bsUtils.toast(err.message || '获取问卷内容失败');
        // }
      }
      this.info = {
        headImg: res.url,
        title: res.surveyTitle,
        desc: res.surveyDesc,
        plazaName: res.plazaName,
        storeName: res.storeName,
      };
      // this.questionsInfo.list = this.dealWithQList([
      //   res.categoryVoList[0],
      //   res.categoryVoList[1],
      // ]);
      this.questionsInfo.list = this.dealWithQList(res.categoryVoList);
      // this.questionsInfo.list = this.dealWithQList(
      //   testData.data.categoryVoList
      // );
      this.isCollection = !!Number(res.collectFlag);
      // this.isCollection = true;
      this.refreshCode();

      // await api.updateReadStatus({
      //   id: '231223123',
      //   noticeType: '3',
      // });
    },

    dealWithQList(list) {
      const QUESTION_TYPE = {
        1: 'textarea',
        2: 'radio',
        3: 'checkbox',
      };

      return list.map(item => {
        return {
          name: item.category,
          q: item.topicList.map(qItem => {
            return {
              name: qItem.topicId,
              type: QUESTION_TYPE[qItem.type],
              inputType: qItem.inputType,
              required: qItem.type !== 'textarea',
              title: qItem.topic,
              value: qItem.type === 3 ? [] : '',
              ops: qItem.options ? qItem.options.split('|') : [],
              showCollection: false,
              collection: '',
            };
          }),
        };
      });
    },

    /**
     * 翻页操作
     * @param action 动作
     */

    flipOverHandler(action) {
      this[`${action}Handler`]();
      // this.$refs.content.scrollTop = 0;
      // console.log(this.$refs.qBox.offsetTop + 'px');
      // this.$refs.content.scrollTop = this.$refs.qBox.offsetTop - 20;
      document.querySelector('.questionnaire').scrollTop = 0;
    },
    /**
     * 下一页
     */
    async nextHandler() {
      let currentPage = this.questionsInfo.list[this.questionsInfo.step];
      for (let qI = 0; qI < currentPage.q.length; qI++) {
        if (!currentPage.q[qI].required) continue;
        if (
          !currentPage.q[qI].value.length &&
          currentPage.q[qI].type !== 'textarea'
        ) {
          return this.$bsUtils.toast(`第${qI + 1}题尚未填写！`);
        }

        if (currentPage.q[qI].type === 'textarea') {
          if (isEmojiCharacter(currentPage.q[qI].value)) {
            return this.$bsUtils.toast(`第${qI + 1}题含有Emoji特殊字符！`);
          } else if (currentPage.q[qI].inputType === 1) {
            if (isNaN(Number(currentPage.q[qI].value))) {
              return this.$bsUtils.toast(`第${qI + 1}题只能为纯数字！`);
            }
          }
        }
      }
      if (this.questionsInfo.list.length === this.questionsInfo.step + 1) {
        let processTextarea = this.submitParams.map(item => {
          if (!item.response) {
            item.response = '无';
          } else {
            item.response = item.response.trim();
          }
          return item;
        });

        this.submitParams2 = Object.assign(
          {
            surveyId: this.queryParams && this.queryParams.eventId,
          },
          { respList: processTextarea, name: this.$store.state.account.name }
        );

        if (this.isCollection) {
          this.refreshCode();
          this.showCollection = this.dealWithHasCollection();
          this.collectionValue = '';
          return (this.showCAPTCHA = true);
        }

        await this.submitQuestion(this.submitParams2);
      } else {
        this.questionsInfo.step += 1;
      }
    },
    /**
     * 所有选择项答案为“满意”或“非常满意”时，提交后给出弹框，让商户填写满意原因（最少20个字）
     * @returns {boolean}
     */
    dealWithHasCollection() {
      let flag = true;
      const answer = [
        ...new Set(
          this.questionsInfo.list
            .map(item => {
              return item.q
                .filter(qItem => qItem.type === 'radio')
                .map(qItem => qItem.value);
            })
            .flat()
        ),
      ];
      for (let item of answer) {
        if (!['满意', '比较满意', '非常满意'].includes(item)) {
          flag = false;
          break;
        }
      }
      return flag;
    },
    confirmCAPTCHA() {
      // if (this.dealWithHasCollection()) {
      //   if (!this.collectionValue) {
      //     return this.$bsUtils.toast('验证码输入错误');
      //   }
      // }

      console.log('this.showCollection', this.showCollection); // eslint-disable-line no-console

      if (this.showCollection) {
        if (isEmojiCharacter(this.collectionValue)) {
          return this.$bsUtils.toast('满意原因含有Emoji特殊字符！');
        } else if (this.collectionValue.length < 20) {
          return this.$bsUtils.toast('满意原因最少输入20字');
        }
      }

      if (!this.CAPTCHARight) {
        this.refreshCode();
        this.identifyCodeValue = '';
        return this.$bsUtils.toast('验证码输入错误');
      } else {
        this.submitParams2.reason = this.collectionValue;
        this.submitQuestion(this.submitParams2);
      }
    },
    async submitQuestion(params) {
      if (this.hasCommit) return false;

      // params;
      // this.hasCommit = true;
      // this.showCAPTCHA = false;
      // this.$bsUtils.toast('提交成功！');
      await questionnaireApi
        .submitSurvey(JSON.stringify(params))
        .then(() => {
          this.hasCommit = true;
          this.showCAPTCHA = false;
          this.$bsUtils.toast('提交成功！');
        })
        .catch(err => {
          this.$bsUtils.toast(err.message || '提交失败！');
        });
    },
    /**
     * 上一页
     */
    prevHandler() {
      this.questionsInfo.step -= 1;
    },
    refreshCode() {
      this.identifyCode = '';
      this.makeCode(4);
    },
    randomNum(min, max) {
      max = max + 1;
      return Math.floor(Math.random() * (max - min) + min);
    },
    // 随机生成验证码字符串
    makeCode(len) {
      const str =
        '0123456789qwertyuiopasdfghjklzxcvbnmQWERTYUIOPASDFGHJKLZXCVBNM';
      for (let i = 0; i < len; i++) {
        this.identifyCode += str[this.randomNum(0, str.length - 1)];
      }
    },
  },
};
</script>

<style lang="less" scoped>
@font-face {
  font-family: qtitle;
  src: url('../../assets/font/questionnaire/q_title.ttf');
}
.bs-wrapper {
  // padding-top: 10px;
  // max-height: calc(100% - 44px);
  overflow: auto;
  /*解决ios上滑动不流畅*/
  -webkit-overflow-scrolling: touch;
}
.questionnaire {
  background: #f4f4f4;
  // .content {
  //   flex: 1;
  //   overflow-y: auto;
  // }
  .q-loading {
    line-height: initial;
    top: 50%;
    transform: translateY(-50%);
  }
  .img-box {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    height: 234px;
    overflow: hidden;
    z-index: 1;
    font-family: qtitle;
    color: #ffffff;
    line-height: 234px;
    font-size: 32px;
  }
  .img-text {
    margin-top: -70px;
    display: -webkit-box;
    line-height: 1.05;
    overflow: hidden;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .tip-box {
    box-sizing: border-box;
    margin: -25px 8px 8px;
    padding: 20px 14px;
    font-size: 14px;
    font-weight: 400;
    color: #666666;
    line-height: 22px;
    text-align: left;
    z-index: 2;
    background: #fff;
  }
  .q-box {
    margin: 0 8px;
    overflow: hidden;
    padding-bottom: 10px;
    .q-header {
      justify-content: space-between;
      padding: 20px 14px 0;
      .title {
        font-size: 16px;
        font-weight: 500;
        color: #333333;
        line-height: 16px;
      }
      .step {
        font-size: 12px;
        font-weight: 500;
        color: #999999;
        line-height: 16px;
      }
    }
  }
  .btn-box {
    justify-content: space-between;
    margin: 40px 10px;
  }
  .plaza-box {
    margin-top: 10px;
    padding: 16px 14px;
  }
}

.CAPTCHABox {
  position: relative;
  justify-content: center;
  margin-top: 12px;
  box-sizing: border-box;
  padding-bottom: 6px;
  height: 80px;
  align-items: center;
  .CAPTCHAInput {
    flex: 1;
    height: 40px;
    border-bottom: 1px solid #919090;
  }
  & > i {
    //margin-top: 15px;
  }
  .s-canvas {
    border: 1px solid #ccc;
    height: 40px;
    margin-left: 10px;
    margin-right: 4px;
    overflow: hidden;
  }
  .nullBox {
    position: absolute;
    top: 0;
    right: 29px;
    width: 100px;
    height: 40px;
    background: red;
    opacity: 0;
  }
}

.collectionBox {
  width: 355px;
  /deep/.van-dialog__content {
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    padding: 0 12px;
    .collection {
      margin-top: 4px;
      border: 1px solid #ccc;
      border-radius: 6px;
    }
    .btns {
      display: flex;
      .btn {
        flex: 1;
        &.confirm {
          color: #f54350;
        }
      }
    }
  }
}
</style>
